import styled from "styled-components";

export const CarouselWithCardsWrapper = styled.div`
  // WARNING: bespoke media query
  @media (min-width: 100rem) {
    width: 100%;
    overflow-x: hidden;
    cursor: none; // hide cursor only on laptop, check MouseCursor breakpoint
  }
  a,
  button {
    cursor: pointer;
  }
`;

export const Inner = styled.div`
  position: relative;
  // WARNING: bespoke media query
  @media (min-width: 100rem) {
    width: 100rem;
    
    .swiper {
      overflow: visible;
    }
  }
  // The '105rem' comes from 'calc(100rem + var(--page-margin) * 2)'.
  // I know, it sucks.
  // TODO: refactor as this approach will cause issue as soon --page-margin is updated
  @media (min-width: 105rem) {
    margin-left: calc((100% - 100rem - var(--page-margin) * 2) / 2);
  }
`;
